<p class="line-height-1rem mr-2 mb-1" *ngIf="SysContactUtilSrv.hasInstitutionName(sysVar)">
  <small class="font-footer-contact-title">{{ SysContactUtilSrv.getInstitutionName(sysVar) }}</small>
</p>
<p class="line-height-1rem mr-2 mb-0" *ngIf="SysContactUtilSrv.hasAddress(sysVar)">
  <small class="font-footer-contact-details">{{ SysContactUtilSrv.getAddress(sysVar) }}</small>
</p>
<p class="line-height-1rem mr-2 mb-0" *ngIf="SysContactUtilSrv.hasCityLine(sysVar)">
  <small class="font-footer-contact-details">{{ SysContactUtilSrv.getCityLine(sysVar)}}</small>
</p>
<p class="line-height-1rem mr-2 mb-0" *ngIf="SysContactUtilSrv.hasCountry(sysVar)">
  <small class="font-footer-contact-details">{{ SysContactUtilSrv.getCountry(sysVar) }}</small>
</p>
<p class="line-height-1rem mr-2 mb-0" *ngIf="SysContactUtilSrv.hasContactPhone1(sysVar)">
  <small class="font-footer-contact-details">{{ "LABEL_PHONE" | translate }}: {{ SysContactUtilSrv.getContactPhone1(sysVar) }}</small>
</p>
<p class="line-height-1rem mr-2 mb-2" *ngIf="SysContactUtilSrv.hasContactEmail(sysVar)">
  <small class="font-footer-contact-details">{{ "LABEL_EMAIL" | translate }}: {{ SysContactUtilSrv.getContactEmail(sysVar) }}</small>
</p>
<p class="mb-0 line-height-1rem mr-2">
  <small class="font-footer-contact-details">{{ SysContactUtilSrv.getCopyRightMessage(sysVar) }}</small>
</p>
